import { Button, ClickAwayListener, Divider, Grid, IconButton, List, ListItem, Paper, Popper, Switch, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useNavigate } from 'react-router-dom';
import globalStyles from "../../../assets/styles/global.module.scss";
import chatbotStyles from "../../../assets/styles/componentStyles/chatbotList.module.scss";
import individualAvatar from "../../../assets/chatbotProfileAvtar.png";
import styles from "../../../assets/styles/componentStyles/template.module.scss";
import AddIcon from '@mui/icons-material/Add';
import agent from '../../../services/api';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import deleteIcon from '../../../assets/deleteIcon.svg'
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import noDataFound from '../../../assets/CampaignNoDataFound.png'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import GlobalPopUp from '../../utility/globalPopUp';
import { checkForErrorCode, filterCustomChatbots, filterSampleChatbots, flagCookieExpired, flagCreditsExhausted, flagShowGetStartedPage, getErrorMessage, getIntegrationIcon, isDev } from '../../../utils/constants';
import { primaryColor } from '../../../utils/colors';
import IconsColor from '../../utility/iconsColor';
import ErrorIcon from '@mui/icons-material/Error';
import EmptyState from '../../global/emptyState';
import ChatbotEmptyStateIcon from "../../../assets/images/chatbot/chatbotEmptyState.png";
import GlobalButton from '../../utility/globalButton/button';
import EastIcon from '@mui/icons-material/East';
import GlobalSearch from '../../utility/GlobalSearch/GlobalSearch';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import ScheduleMeetingAIChatbot from '../../utility/scheduleMetting/scheduleMeetingAIChatbot';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { isChannelNameWebsiteOrChronox } from '../../../pages/ruleBasedInbox/utils';
import chatbotProfilePictureDefault from "../../../assets/chatbotProfileAvtar.png";
import GlobalTooltip from '../../utility/tooltip/globalTooltip';

interface sampleList {
    sampleChatbots?: any
}

const ChatbotList = (props: sampleList) => {
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 600px)')
    const innerHeight = flagSmallScreen ? (window.innerHeight - 230) : (window.innerHeight - 190);

    const navigate = useNavigate()
    const { userDetail, setFlagLoading, flagLoading, showLoginPopup, setFlagShowCreditsExhausted, setUserDetail, handleError, setFlagShowScheduleCall } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotListApi, setChatBotDetails, chatbotList, setChatbotList } = useContext(ChatbotContext) as ChatbotContextPayload
    const { setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [openUpgradationpopup, setUpgradationpopup] = useState(false)
    const [deleteChatBotDetails, setDeleteChatBotDetails] = useState({
        chatbot_id: '',
        chatbot_name: ''
    })
    const [chatbotOriginalDetails, setChatbotOriginalDetails] = useState<any | null>(null);
    const [askUserToSigninPopupData, setAskUserToSigninPopupData] = useState({
        heading: "Welcome to our exclusive Chatbot feature, reserved for our premium users! 🌟 As a valued member of our community, we invite you to experience the full power of our Chatbot capabilities to create and customize your own chatbot with a personalized knowledge base..",
        subHeading: "   Sign in now to claim your 10-day free premium trial and gain instant access to the Spell Checker tab. With premium access, you'll enjoy error-free writing, enhanced grammar suggestions, and a seamless writing experience.",
        content: "Don't miss out on this opportunity to elevate your writing to new heights. Join our premium community today and start perfecting your content effortlessly!"
    })
    const [flagSampleChatbot, setFlagSampleChatbot] = useState(false);
    const [openMenu, setOpenMenu] = useState(null)
    const [anchorEl, setAnchorEl] = useState<any>(null)

    const [flagScheduleMeetingPopup, setFlagScheduleMeetingPopup] = useState<boolean>(false);

    const handleClose = () => {
        setOpenMenu(null);
        setAnchorEl(null);
    }

    useEffect(() => {
        if (showLoginPopup) {

        } else {
            if (userDetail.flagUser) {
                if (userDetail.flag_user_anonymous) {
                    setUpgradationpopup(true)
                } else {
                    if (userDetail.user_role && (userDetail.user_role.user_role_name === "Developer" || userDetail.user_role.user_role_name === "Admin")) {
                    } else {
                        if (userDetail.plan_detail && userDetail?.plan_detail?.credit_usage_data && userDetail?.plan_detail?.credit_usage_data != null && userDetail.plan_detail.credit_usage_data != null && (userDetail?.plan_detail?.credit_usage_data?.stripe_product_name == null || userDetail?.plan_detail?.credit_usage_data?.stripe_product_name === "Free")) {
                            setAskUserToSigninPopupData({
                                heading: "Welcome to our exclusive Chatbot feature, reserved for our premium users! 🌟 As a valued member of our community, we invite you to experience the full power of our Chatbot capabilities to create and customize your own chatbot with a personalized knowledge base..",
                                subHeading: "Sign in now to claim your 10-day free premium trial and gain instant access to the Spell Checker tab. With premium access, you'll enjoy error-free writing, enhanced grammar suggestions, and a seamless writing experience.",
                                content: "Don't miss out on this opportunity to elevate your writing to new heights. Join our premium community today and start perfecting your content effortlessly!"
                            })
                            setUpgradationpopup(true)
                        }
                    }
                }
            } else {
                setUpgradationpopup(true)
            }
        }
    }, [userDetail, showLoginPopup])

    useEffect(() => {
        if (!props.sampleChatbots) {

            if(flagShowGetStartedPage(userDetail)){
                setFlagScheduleMeetingPopup(true);
            } else {
                (async () => {
                    setFlagLoading({ ...flagLoading, flagRoundLoader: true });
                    setChatBotDetails(null)
                    let chatBotResponse = await GetChatbotListApi()
                    if (chatBotResponse?.status) {
                        if (chatBotResponse?.data?.length) {
                            setChatbotOriginalDetails(chatBotResponse.data)
                        } else {
                            setChatbotOriginalDetails(null)
                            setFlagLoading({ ...flagLoading, flagRoundLoader: false });
                        }
                    } else {
                        setChatbotList(null)
                        setChatbotOriginalDetails(null)
                        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
                        handleError(chatBotResponse);
                    }
                    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
                })()
            }
        }
    }, [])


    const handleViewChatbot = async (chatbot_id: number) => {
        navigate(`/chatbot/viewChatbot?chatbot_id=${chatbot_id}`)
    }
    const handleDeleteBot = async (id: any) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const response = await agent.removeChatbot.delete(id)
        if (response.status) {
            if (response?.status) {
                if (response.data.length) {
                    setChatbotList(response.data)
                    setChatbotOriginalDetails(response.data)
                } else {
                    setChatbotList(null)
                    setChatbotOriginalDetails(null)
                }
            } else {
                setChatbotList(null)
                setChatbotOriginalDetails(null)
                handleError(response);
            }
            setOpenDeletePopup(false)
            showSuccess("Chatbot Deleted Successfully!")
        } else {
            let errorCode = checkForErrorCode(response)
            if (flagCookieExpired(userDetail, errorCode)) {
                handleError(response);
            } else {
                if (flagCreditsExhausted(errorCode)) {
                    setFlagShowCreditsExhausted(true)
                } else if (response.message == "canceled") {
                }
                else {
                    showError(getErrorMessage(errorCode, isDev(userDetail), response))
                }
            }
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    };

    const handleSampleChatbots = () => {
        setFlagSampleChatbot(true);
    }

    const handleSearch = (event: any) => {
        const query = event?.target?.value?.toLowerCase()
        if (chatbotList != null) {
            const chatbotFilterData = chatbotList.filter((chatbot: any) => {
                return (
                    chatbot.chatbot_name !== null && chatbot?.chatbot_name?.toLowerCase().includes(query)

                )
            })
            setChatbotOriginalDetails(chatbotFilterData)
        }
    }

    const handleCreateChatbot = () => {
        navigate("/createChatbot")
    }
    const handleUpdateFlagInternal = async (chatbotDetails: any, flagValue: string, value: any) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let flagPublic = chatbotDetails.chatbot_flag_public;
        let flagInternal = chatbotDetails.flag_internal_only
        if (flagValue == 'flagInternal') {
            flagInternal = value;
            if (value == true) {
                flagPublic = !value
            }
        } else {
            flagPublic = value;
            if (value == true) {
                flagInternal = !value
            }
        }
        let payload = {
            chatbot_id: chatbotDetails.chatbot_id,
            chatbot_flag_public: flagPublic,
            flag_internal_only: flagInternal
        }
        const response = await agent.updateFlagInternal.put(payload)
        let errorRes = null;
        if (response.status) {
            showSuccess("Chatbot updated successfully!")
            // GetChatbotListApi()
            const res = await GetChatbotListApi();
            if (res.status) {
                setChatbotOriginalDetails(res?.data);
            }
            else errorRes = res;
        } else errorRes = response;
        if(errorRes){
            handleError(errorRes);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }


    return (
        <>

            {openDeletePopup && (
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to delete ${deleteChatBotDetails.chatbot_name} chatbot`}
                    open={openDeletePopup}
                    onClose={() => {
                        setOpenDeletePopup(false)
                    }}
                    onDelete={() => {
                        handleDeleteBot(deleteChatBotDetails.chatbot_id)
                        setOpenDeletePopup(false)
                    }}
                />
            )
            }

            {flagSampleChatbot &&
                <GlobalPopUp
                    titlePadding={flagSmallScreen ? "40px 25px 20px" : "50px 40px 20px"}
                    paperMinWidth={flagSmallScreen ? "92%" : "85%"}
                    paperMaxwidth={flagSmallScreen ? "92%" : "85%"}
                    height={"100%"}
                    open={flagSampleChatbot}
                    onClose={() => { setFlagSampleChatbot(false); handleClose(); }}
                    title={"Sample Chatbots"}
                    flagShowCloseIcon={true}
                    titleAlignment={"start"}
                    handleClose={() => { setFlagSampleChatbot(false); handleClose(); }}
                >
                    <Grid item>
                        <ChatbotList sampleChatbots={true} />
                    </Grid>
                </GlobalPopUp>
            }
            
            {flagScheduleMeetingPopup ? 
                <ScheduleMeetingAIChatbot />
                :
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                    <Grid container className={`${styles.chatbotGrid} ${props.sampleChatbots ? styles.sampleChatbotPadding : styles.mainScreenPadding}`}> 
                        {props.sampleChatbots ?
                            <>
                                <Grid item className={styles.sampleChatbotsGrid}>
                                    <Grid container>
                                        <>
                                            {chatbotList && filterSampleChatbots(chatbotList)?.length > 0 &&
                                                filterSampleChatbots(chatbotList).map((bot: any, index: number) => (
                                                    <React.Fragment key={bot.chatbot_id}>
                                                        <Grid item xl={2.3} lg={3} md={4} sm={12} xs={12}
                                                            className={chatbotStyles.personaCreatedList}
                                                            onClick={() => { handleViewChatbot(bot.chatbot_id) }}
                                                        >
                                                            <Popper
                                                                key={index}
                                                                anchorEl={anchorEl}
                                                                onClick={handleClose}
                                                                open={openMenu == bot.chatbot_id}
                                                                id="composition-menu"
                                                                aria-labelledby="composition-button"
                                                                sx={{ zIndex: "99999" }}
                                                            >
                                                                <Paper key={index} sx={{ zIndex: "99999" }}>
                                                                    <ClickAwayListener onClickAway={handleClose}>
                                                                        <List>
                                                                            <ListItem
                                                                                key={index}
                                                                                onClick={(e) => { e.stopPropagation() }}>
                                                                                <Grid container gap="20px" justifyContent={"space-between"} alignItems={"center"}>
                                                                                    <Grid item className={globalStyles.displayFlex}>Flag Public</Grid>
                                                                                    <Grid item><Switch checked={bot.chatbot_flag_public} onChange={(event: React.ChangeEvent<HTMLInputElement>) => { handleUpdateFlagInternal(bot, 'flagPublic', event.target.checked); handleClose(); }} /></Grid>
                                                                                </Grid>
                                                                            </ListItem>
                                                                            <ListItem
                                                                                key={index}
                                                                                onClick={(e) => { e.stopPropagation() }}>
                                                                                <Grid container gap="20px" justifyContent={"space-between"} alignItems={"center"}>
                                                                                    <Grid item className={globalStyles.displayFlex}>Flag Internal</Grid>
                                                                                    <Grid item><Switch checked={bot.flag_internal_only} onChange={(event: React.ChangeEvent<HTMLInputElement>) => { handleUpdateFlagInternal(bot, 'flagInternal', event.target.checked); handleClose(); }} /></Grid>
                                                                                </Grid>
                                                                            </ListItem>
                                                                        </List>
                                                                    </ClickAwayListener>
                                                                </Paper>

                                                            </Popper>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <Grid container className={chatbotStyles.chatbotProfileAvtarContainer} >


                                                                        <Grid item className={`${chatbotStyles.chatbotProfileAvtarItem} ${bot?.chatbot_logo_id ? chatbotStyles.transparentBackground : chatbotStyles.defaultBackground}`}>
                                                                            <img src={bot?.chatbot_logo_url ? bot.chatbot_logo_url : individualAvatar} alt="chatbot Icon" className={bot?.chatbot_logo_id ? chatbotStyles.chatbot_icon : chatbotStyles.default_icon} />


                                                                        </Grid>

                                                                        <Grid item >
                                                                            <Grid container gap="5px" sx={{ height: "24px" }}>
                                                                                {isDev(userDetail) && bot.flag_internal_only &&
                                                                                    <Grid item className={globalStyles.displayFlex}>
                                                                                        <GlobalTooltip
                                                                                            title="Flag Internal true"
                                                                                            placement='top'
                                                                                            arrow
                                                                                        >
                                                                                            <ErrorIcon sx={{ color: "#CA0035", fontSize: "22px !important" }} />
                                                                                        </GlobalTooltip>
                                                                                    </Grid>}
                                                                                {isDev(userDetail) &&
                                                                                    <IconButton sx={{ padding: "0px !important" }} onClick={(e) => { e.stopPropagation(); setOpenMenu(bot.chatbot_id); setAnchorEl(e.currentTarget) }} aria-label='settings'>
                                                                                        <IconsColor iconName="settings" fillColor="#7A7A7A" width="18" height="18" />
                                                                                    </IconButton>}
                                                                                {bot.chatbot_flag_edit &&
                                                                                    <Grid item className={globalStyles.displayFlex}>
                                                                                        <IconButton
                                                                                            aria-label='delete'
                                                                                            size="small"
                                                                                            sx={{ padding: "0px 5px !important" }}
                                                                                            onClick={(e: any) => { e.stopPropagation(); setDeleteChatBotDetails(bot); setOpenDeletePopup(true) }}
                                                                                        >
                                                                                            <img src={deleteIcon} alt="delete" className={globalStyles.cardDeleteIcon} />
                                                                                        </IconButton>
                                                                                    </Grid>}
                                                                                {bot.chatbot_flag_public &&
                                                                                    <Grid item sx={{ width: "auto" }} marginLeft={1}>

                                                                                        <Grid item className={chatbotStyles.sampleChatbot}>Sample Chatbot</Grid>

                                                                                    </Grid>
                                                                                }

                                                                            </Grid>
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} className={chatbotStyles.chatbotNameItem}>
                                                                    <Typography component={'span'} className={`${chatbotStyles.chatbotHeadText} ${globalStyles.cardHeaderFontSize}`}>{bot.chatbot_name}</Typography>
                                                                </Grid>
                                                                <Grid item sx={{ marginTop: "15px" }}>
                                                                    <GlobalButton endIcon={<EastIcon sx={{ color: "#fff" }} />} buttonText={"Try it"} sx={{ fontSize: "13px !important" }} className='primaryButtonStyle' onClick={() => { handleViewChatbot(bot.chatbot_id) }} />
                                                                </Grid>


                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                ))
                                            }
                                        </>
                                    </Grid>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={12}>
                                    <Grid container sx={{ alignItems: "center" }}>
                                        <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                                            <GlobalPageHeaderText
                                                mainHeadText={"AI Chatbot"}
                                                flagMainTextOnly
                                                actionBlock={<>  <Grid item >
                                                    <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} >
                                                        {(chatbotList == null || chatbotList == undefined) ?
                                                            (<> </>) : (
                                                                <>

                                                                    <Grid item
                                                                        className={`
                                                                    ${styles.headRightSubItem}`}>
                                                                        <Grid container className={globalStyles.trySampleChatbotContainer}>
                                                                            <Grid item
                                                                            >
                                                                                <Button
                                                                                    variant='outlined'
                                                                                    size='large'
                                                                                    fullWidth
                                                                                    className={globalStyles.sampleChatbotBtn}
                                                                                    onClick={() => { handleSampleChatbots() }}
                                                                                    endIcon={<EastIcon sx={{ color: primaryColor }} />}
                                                                                    aria-label='Try Sample Chatbot'
                                                                                >
                                                                                    Try Sample Chatbot
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid item
                                                                    >
                                                                        <Grid container className={globalStyles.createChatbotContainer}>
                                                                            <Grid item className={`
                                                                        ${styles.addChatbotBtn}`}>
                                                                                <Button
                                                                                    variant='outlined'
                                                                                    size='large'
                                                                                    sx={{ width: "178px" }}
                                                                                    fullWidth
                                                                                    startIcon={<IconsColor iconName="plus" fillColor="#fff" width="15px" height="15px" />}
                                                                                    className={globalStyles.addDocumentBtn}
                                                                                    onClick={() => { handleCreateChatbot() }}
                                                                                    aria-label='Create Chatbot'
                                                                                >
                                                                                    Create Chatbot
                                                                                </Button>
                                                                            </Grid>
                                                                            <IconButton
                                                                                className={`${globalStyles.cmpGlobalMobileAddIcon} ${styles.addChatbotIcon}`}
                                                                                onClick={() => { handleCreateChatbot() }}
                                                                                aria-label='add'
                                                                            >
                                                                                <AddIcon className={globalStyles.addIconStyles} />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            )
                                                        }
                                                    </Grid>
                                                </Grid></>}
                                            />
                                        </Grid>

                                        <Divider className={`${globalStyles.dividerStyles} ${styles.dividerStyle}`} sx={{ paddingTop: "6px !important" }} />
                                    </Grid>
                                </Grid>

                                <Grid item sx={{ width: "100%" }}>
                                    <Grid container mt={"10px"} justifyContent={{ xs: "start", sm: "end" }}>
                                        <Grid item className={`${globalStyles.globalSearchbarSubItem}`}>
                                            <GlobalSearch
                                                fullWidth
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                                size="small"
                                                placeholder="Search"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.listsMainContainer} mt={2} sx={{ maxHeight: `${innerHeight}px !important` }}>
                                    <Grid container>
                                        <>
                                            {chatbotOriginalDetails && filterCustomChatbots(chatbotOriginalDetails).length > 0 ? (
                                                filterCustomChatbots(chatbotOriginalDetails).map((bot: any, index: number) => (
                                                    <React.Fragment key={bot.chatbot_id}>
                                                        <Grid item xl={2.3} lg={3} md={4} sm={12} xs={12}
                                                            className={chatbotStyles.personaCreatedList}
                                                            onClick={() => { handleViewChatbot(bot.chatbot_id) }}
                                                        >
                                                            <Popper
                                                                key={index}
                                                                anchorEl={anchorEl}
                                                                onClick={handleClose}
                                                                open={openMenu == bot.chatbot_id}
                                                                id="composition-menu"
                                                                aria-labelledby="composition-button"
                                                            >
                                                                <Paper key={index}>
                                                                    <ClickAwayListener onClickAway={handleClose}>
                                                                        <List>
                                                                            <ListItem
                                                                                key={index}
                                                                                onClick={(e) => { e.stopPropagation() }}>
                                                                                <Grid container className={globalStyles.flagPopperContainer} >
                                                                                    <Grid item className={globalStyles.displayFlex}>Flag Public</Grid>
                                                                                    <Grid item><Switch checked={bot.chatbot_flag_public} onChange={(event: React.ChangeEvent<HTMLInputElement>) => { handleUpdateFlagInternal(bot, 'flagPublic', event.target.checked); handleClose(); }} /></Grid>
                                                                                </Grid>
                                                                            </ListItem>
                                                                            <ListItem
                                                                                key={index}
                                                                                onClick={(e) => { e.stopPropagation() }}>
                                                                                <Grid container className={globalStyles.flagPopperContainer} >
                                                                                    <Grid item className={globalStyles.displayFlex}>Flag Internal</Grid>
                                                                                    <Grid item><Switch checked={bot.flag_internal_only} onChange={(event: React.ChangeEvent<HTMLInputElement>) => { handleUpdateFlagInternal(bot, 'flagInternal', event.target.checked); handleClose(); }} /></Grid>
                                                                                </Grid>
                                                                            </ListItem>
                                                                        </List>
                                                                    </ClickAwayListener>
                                                                </Paper>

                                                            </Popper>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <Grid container className={globalStyles.startAlignment} >
                                                                        <Grid item className={`${chatbotStyles.chatbotProfileAvtarItem} ${bot?.chatbot_logo_id ? chatbotStyles.transparentBackground : chatbotStyles.defaultBackground}`}>


                                                                            <img src={bot?.chatbot_logo_url ? bot.chatbot_logo_url : individualAvatar} alt="chatbot Icon" className={bot?.chatbot_logo_id ? chatbotStyles.chatbot_icon : chatbotStyles.default_icon} />


                                                                        </Grid>
                                                                        <Grid item >
                                                                            <Grid container className={chatbotStyles.gapAlignment}>
                                                                                {bot.integrations && bot.integrations?.filter((integration: any) => !isChannelNameWebsiteOrChronox(integration))?.length > 0 &&
                                                                                    <Grid item
                                                                                        marginRight={"2px"}
                                                                                    >
                                                                                        <Grid container gap={"6px"}>
                                                                                            {bot.integrations?.filter((integration: any) => !isChannelNameWebsiteOrChronox(integration))?.map((integ: any, ind: number) =>
                                                                                                <IconButton key={ind} sx={{ padding: "0px !important" }} aria-label='integrations'
                                                                                                >
                                                                                                    {getIntegrationIcon(integ, "18", "", chatbotProfilePictureDefault)}
                                                                                                </IconButton>

                                                                                            )}
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                }
                                                                                {isDev(userDetail) && bot.flag_internal_only &&
                                                                                    <Grid item className={globalStyles.displayFlex}>
                                                                                        <GlobalTooltip
                                                                                            title="Flag Internal true"
                                                                                            placement='top'
                                                                                            arrow
                                                                                        >
                                                                                            <ErrorIcon sx={{ color: "#CA0035", fontSize: "22px !important" }} />
                                                                                        </GlobalTooltip>
                                                                                    </Grid>}
                                                                                {isDev(userDetail) &&
                                                                                    <IconButton sx={{ padding: "0px !important" }} onClick={(e) => { e.stopPropagation(); setOpenMenu(bot.chatbot_id); setAnchorEl(e.currentTarget) }} aria-label='settings'>
                                                                                        <IconsColor iconName="settings" fillColor="#7A7A7A" width="18" height="18" />
                                                                                    </IconButton>}
                                                                                {bot.chatbot_flag_edit &&
                                                                                    <Grid item className={globalStyles.displayFlex}>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            aria-label='delete'
                                                                                            sx={{ padding: "0px 5px !important" }}
                                                                                            onClick={(e: any) => { e.stopPropagation(); setDeleteChatBotDetails(bot); setOpenDeletePopup(true) }}
                                                                                        >
                                                                                            <img src={deleteIcon} alt="delete" className={globalStyles.cardDeleteIcon} height={"16"} width={"16"} />
                                                                                        </IconButton>
                                                                                    </Grid>}
                                                                                {bot.chatbot_flag_public &&
                                                                                    <Grid item sx={{ width: "98px" }}>

                                                                                        <Grid item className={chatbotStyles.sampleChatbot}>Sample Chatbot</Grid>

                                                                                    </Grid>
                                                                                }

                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} className={chatbotStyles.chatbotNameItem}>
                                                                    <Typography component={'span'} className={`${chatbotStyles.chatbotHeadText} ${globalStyles.cardHeaderFontSize}`}>{bot.chatbot_name}</Typography>
                                                                </Grid>

                                                                <Grid item xs={9} className={chatbotStyles.conversationBox} mt={2}>
                                                                    <Grid container className={chatbotStyles.conversationBoxContainer} >
                                                                        <Grid item className={chatbotStyles.conversationBoxItem} >
                                                                            <IconsColor iconName="conversations" height="16" width="16" />
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <span className={chatbotStyles.conversationFontStyle}>#Conversations: </span>
                                                                            <span className={chatbotStyles.conversationFontStyle}>{bot.total_chats}</span>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>


                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                ))
                                            ) : (chatbotList !== null && filterCustomChatbots(chatbotList)?.length == 0 ? (
                                                <>
                                                    <EmptyState
                                                        height={'calc(100vh - 250px)'}
                                                        pageIcon={<img alt="chatbot" src={ChatbotEmptyStateIcon} style={{ width: "165px", height: "auto" }} />}
                                                        pageSubText={"No Chatbot Created Yet! Start With a New Chatbot"}
                                                        primaryActionBtn={<GlobalButton
                                                            buttonText={"New Chatbot"}
                                                            className='primaryButtonStyle'
                                                            onClick={handleCreateChatbot}
                                                            startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                        />}
                                                        secondaryActionBtn={<GlobalButton variant='text' className='primaryTextButtonStyle' buttonText={"Try Sample Chatbot"} onClick={() => { setFlagSampleChatbot(true); handleClose(); }} />}
                                                    />
                                                </>
                                            ) : (chatbotOriginalDetails !== null && chatbotOriginalDetails.length == 0 &&
                                                <>
                                                    <Grid item xs={12} className={styles.noDataFoundItem}>
                                                        <EmptyState
                                                            height={'calc(100vh - 250px) !important'}
                                                            pageIcon={<img alt="chatbot" src={noDataFound} />}
                                                            pageText={"No Data Found!"}
                                                        />
                                                    </Grid>
                                                </>
                                            )
                                            )}
                                        </>
                                    </Grid>
                                </Grid>
                            </>}
                    </Grid>
                </Grid >
            }
        </>
    )
}

export default ChatbotList;
